export default {
  defaultSelectionColor: Styles.color.grey.three,
  filtersContainerPadding: '1.5rem 0.5rem',
  moreOptionsTextTransform: 'uppercase',
  titleLineHeight: 1.2,
};
